function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#1972E6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12,4.88888889 L12,0 L0,0 L0,22 L24,22 L24,4.88888889 L12,4.88888889 Z M4.8,19.5555556 L2.4,19.5555556 L2.4,17.1111111 L4.8,17.1111111 L4.8,19.5555556 Z M4.8,14.6666667 L2.4,14.6666667 L2.4,12.2222222 L4.8,12.2222222 L4.8,14.6666667 Z M4.8,9.77777778 L2.4,9.77777778 L2.4,7.33333333 L4.8,7.33333333 L4.8,9.77777778 Z M4.8,4.88888889 L2.4,4.88888889 L2.4,2.44444444 L4.8,2.44444444 L4.8,4.88888889 Z M9.6,19.5555556 L7.2,19.5555556 L7.2,17.1111111 L9.6,17.1111111 L9.6,19.5555556 Z M9.6,14.6666667 L7.2,14.6666667 L7.2,12.2222222 L9.6,12.2222222 L9.6,14.6666667 Z M9.6,9.77777778 L7.2,9.77777778 L7.2,7.33333333 L9.6,7.33333333 L9.6,9.77777778 Z M9.6,4.88888889 L7.2,4.88888889 L7.2,2.44444444 L9.6,2.44444444 L9.6,4.88888889 Z M21.6,19.5555556 L12,19.5555556 L12,17.1111111 L14.4,17.1111111 L14.4,14.6666667 L12,14.6666667 L12,12.2222222 L14.4,12.2222222 L14.4,9.77777778 L12,9.77777778 L12,7.33333333 L21.6,7.33333333 L21.6,19.5555556 Z M19.2,9.77777778 L16.8,9.77777778 L16.8,12.2222222 L19.2,12.2222222 L19.2,9.77777778 Z M19.2,14.6666667 L16.8,14.6666667 L16.8,17.1111111 L19.2,17.1111111 L19.2,14.6666667 Z",
  transform: "translate(14 15)"
}));

var SvgGoogleAdminContactsIco = function SvgGoogleAdminContactsIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleAdminContactsIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_admin_contacts_ico.4c958e76.svg";
export { ForwardRef as ReactComponent };